var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"iScroll",rawName:"v-iScroll"}],staticClass:"urban-design"},[_c('gap',{attrs:{"height":73}}),_c('Design'),_c('gap',{attrs:{"height":73}}),_c('Service'),_vm._l((_vm.langPackage.projects),function(item){return [_c('OnSaleProjects',{key:item.title,attrs:{"list":item}})]}),_c('gap',{attrs:{"height":174}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }